module.exports = __webpack_public_path__ + "assets/img/bronze-shield.c4a93c65.png";